export const GSTIN_REGEX =
  /^([0][1-9]|[1-2][0-9]|3[0-7])[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

// GSTIN is optional everywhere: empty is valid, a present value must match the
// standard 15-char format.
export function validateGSTIN(gstin?: string | null): boolean {
  if (!gstin || gstin.trim() === '') return true;
  return GSTIN_REGEX.test(gstin.trim().toUpperCase());
}
